import PaymentTransaction from '../requests/PaymentTransaction';
import Transaction from '../services/Transaction';
import SaleTransaction from '../requests/SaleTransaction';
import Settings from '../models/Settings';
import Response from '../base/Response';

export default class RouterManager {
	/**
	 * Payment transaction
	 */
	transaction: PaymentTransaction;

	/**
	 * PixelPay transaction authentication identifier
	 */
	identifier?: string;

	/**
	 * Initialize service
	 */
	constructor(request: PaymentTransaction) {
		this.transaction = request;
		this.transaction.source = 'router';
	}

	/**
	 * Initialize manager
	 */
	async init(payload: string): Promise<Response> {
		const service = new Transaction(this.parsePayload(payload));
		Transaction.busy = false;

		if (this.transaction instanceof SaleTransaction) {
			return await service.doSale(this.transaction);
		} else {
			return await service.doAuth(this.transaction);
		}
	}

	/**
	 * Parse the payload string to Object Settings
	 */
	private parsePayload(payload: string): Settings {
		const obj_payload = JSON.parse(atob(payload));
		const settings = new Settings();

		settings.setupEnvironment(obj_payload.env);
		settings.setupCredentials(obj_payload.auth_key, obj_payload.auth_hash);
		settings.setupEndpoint(obj_payload.endpoint);
		settings.setupLanguage(this.transaction.lang);

		obj_payload.auth_user && settings.setupPlatformUser(obj_payload.auth_user);

		return settings;
	}
}
